import { useState } from "react";

const groups = [
  {
    title: "内容",
    links: [
      { href: "#new", label: "新番速递" },
      { href: "#top", label: "高分榜" },
      { href: "#category", label: "主题分类" },
      { href: "#review", label: "最新评测" },
    ],
  },
  {
    title: "帮助",
    links: [
      { href: "#faq", label: "常见问题" },
      { href: "#about", label: "关于我们" },
      { href: "#home", label: "回到顶部" },
    ],
  },
];

export default function Footer() {
  const [formStatus, setFormStatus] = useState<{ type: "idle" | "ok" | "error"; msg: string }>({
    type: "idle",
    msg: "",
  });

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = fd.get("contact_alt")?.toString().trim() ?? "";
    if (honeypot) {
      setFormStatus({ type: "ok", msg: "感谢你的留言，我们会尽快与你联系。" });
      form.reset();
      return;
    }
    const email = fd.get("email")?.toString().trim() ?? "";
    const msg = fd.get("message")?.toString().trim() ?? "";
    if (!email || !msg) {
      setFormStatus({ type: "error", msg: "请填写邮箱和留言内容后再提交。" });
      return;
    }
    try {
      const res = await fetch("https://readdy.ai/api/form/da2mi1aamq5jpe1hs0m0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          email,
          message: msg,
        } as Record<string, string>),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const meta = parsed?.meta as Record<string, unknown> | undefined;
      const serverMsg = (meta?.message as string) ?? (meta?.detail as string) ?? "";
      const lower = `${serverMsg} ${text}`.toLowerCase();
      if (res.ok && code === "OK" && !lower.includes("spam")) {
        setFormStatus({ type: "ok", msg: "感谢你的留言，我们会尽快与你联系。" });
        form.reset();
      } else {
        setFormStatus({
          type: "error",
          msg: serverMsg && serverMsg !== "form data is spam" ? serverMsg : "提交失败，请稍后再试。",
        });
      }
    } catch {
      setFormStatus({ type: "error", msg: "网络异常，请稍后再试。" });
    }
  }

  return (
    <footer id="contact" className="relative w-full border-t border-background-800/60 bg-background-900 py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-sailboat-line text-lg" />
              </span>
              <span className="font-heading text-xl text-foreground-50">漫镜</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-400">
              追番的一站式灯塔。新番情报、高分榜单、深度评测与主题分类，聚合优质动漫资讯，帮你高效选番。
            </p>
          </div>

          {groups.map((g) => (
            <div key={g.title}>
              <h3 className="text-sm font-medium text-foreground-100">{g.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {g.links.map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="text-sm text-foreground-400 transition-colors hover:text-primary-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="text-sm font-medium text-foreground-100">联系我们</h3>
            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="mt-4 flex flex-col gap-3"
            >
              <input
                name="email"
                type="email"
                required
                placeholder="你的邮箱"
                className="w-full rounded-md border border-background-700 bg-background-950 px-3 py-2.5 text-sm text-foreground-100 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none"
              />
              <textarea
                name="message"
                required
                rows={3}
                maxLength={500}
                placeholder="想对我们说的话（500 字以内）"
                className="w-full resize-none rounded-md border border-background-700 bg-background-950 px-3 py-2.5 text-sm text-foreground-100 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none"
              />
              <input
                name="contact_alt"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="field-guard-contact"
              />
              <button
                type="submit"
                className="rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
              >
                提交留言
              </button>
              {formStatus.type === "ok" && (
                <p className="text-xs text-accent-300">{formStatus.msg}</p>
              )}
              {formStatus.type === "error" && (
                <p className="text-xs text-primary-300">{formStatus.msg}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-12 border-t border-background-800/60 pt-6">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">© 2026 漫镜 ACG · 专注动漫资讯与正版内容导航，不提供任何盗版下载。</p>
            <p className="flex items-center gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1"><i className="ri-mail-line" /> hello@manjing.acg</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}